export default remote => ({
    incidents : (data) => remote.post('flight/incidents/today', data)
});
